module.exports = __webpack_public_path__ + "jm.a1434d4cf48823eb86fa.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/jm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/jm.svg
// module chunks = styles